/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkFlowDefinitionDetails extends models.MinimizedWorkFlowForBaseVersion {
    getFixupPrototypeFunction() { return WorkFlowDefinitionDetails.fixupPrototype; }

    static newInstance(model: Partial<WorkFlowDefinitionDetails>): WorkFlowDefinitionDetails {
        let obj = Object.assign(new WorkFlowDefinitionDetails(), model);
        WorkFlowDefinitionDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkFlowDefinitionDetails>): WorkFlowDefinitionDetails {
        if (!model) return null;
        return WorkFlowDefinitionDetails.newInstance(<WorkFlowDefinitionDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkFlowDefinitionDetails) {
        if (!obj) return;

        models.WorkFlowDefinitionDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkFlowDefinitionDetails): boolean {
        if (models.MinimizedWorkFlowForBaseVersion.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, WorkFlowDefinitionDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.filters) {
            models.QueryOperator.fixupPrototype(this.filters);
        }
        if (this.actions) {
            for (let val of this.actions) {
                models.WorkFlowActionDetails.fixupPrototype(val);
            }
        }
        if (this.rules) {
            for (let val of this.rules) {
                models.WorkFlowPersistedRule.fixupPrototype(val);
            }
        }
        if (this.notifications) {
            for (let val of this.notifications) {
                models.WorkFlowNotifications.fixupPrototype(val);
            }
        }
    }

    /**
     * Query based on Resource Group, Region, resource_id, resource_name and resource
     */
    filters: models.QueryOperator;

    actions: Array<models.WorkFlowActionDetails>;

    rules: Array<models.WorkFlowPersistedRule>;

    notifications: Array<models.WorkFlowNotifications>;

}
